export default "<app-common-product-rule-template></app-common-product-rule-template>\n";